// @ts-check

/**
 * Returns true when an Apollo operation's variables tree contains a File or
 * Blob. Used to gate the `apollo-require-preflight` header for the
 * apollo-upload-link multipart path.
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export default function operationHasFile(value) {
  if (value == null) return false;
  if (typeof File !== 'undefined' && value instanceof File) return true;
  if (typeof Blob !== 'undefined' && value instanceof Blob) return true;
  if (Array.isArray(value)) return value.some(operationHasFile);
  if (typeof value === 'object')
    return Object.values(/** @type {Record<string, unknown>} */ (value)).some(
      operationHasFile
    );
  return false;
}
